module.exports = __webpack_public_path__ + "static/media/carousel1.8a52fa53.jpeg";